import api from './api';

const dashboardService = {
  // Get dashboard statistics
  getStats: async () => {
    try {
      const response = await api.get('/dashboard/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching dashboard stats:', error);
      throw error;
    }
  },

  // Get summary statistics
  getSummaryStats: async () => {
    try {
      const response = await api.get('/dashboard/summary');
      return response.data;
    } catch (error) {
      console.error('Error fetching summary stats:', error);
      throw error;
    }
  },

  // Get active trips
  getActiveTrips: async () => {
    try {
      const response = await api.get('/dashboard/active-trips');
      return response.data;
    } catch (error) {
      console.error('Error fetching active trips:', error);
      throw error;
    }
  },

  // Get upcoming tasks
  getUpcomingTasks: async () => {
    try {
      const response = await api.get('/dashboard/upcoming-tasks');
      return response.data;
    } catch (error) {
      console.error('Error fetching upcoming tasks:', error);
      throw error;
    }
  },

  // Get recent documents
  getRecentDocuments: async () => {
    try {
      const response = await api.get('/dashboard/recent-documents');
      return response.data;
    } catch (error) {
      console.error('Error fetching recent documents:', error);
      throw error;
    }
  },

  // Get operational KPIs
  getOperationalKPIs: async () => {
    try {
      const response = await api.get('/dashboard/operational-kpis');
      return response.data;
    } catch (error) {
      console.error('Error fetching operational KPIs:', error);
      throw error;
    }
  },

  // Get performance metrics
  getPerformanceMetrics: async () => {
    try {
      const response = await api.get('/dashboard/performance-metrics');
      return response.data;
    } catch (error) {
      console.error('Error fetching performance metrics:', error);
      throw error;
    }
  },

  // Create quick trip
  createQuickTrip: async (tripData) => {
    try {
      const response = await api.post('/trips', tripData);
      return response.data;
    } catch (error) {
      console.error('Error creating quick trip:', error);
      throw error;
    }
  },

  // Schedule maintenance
  scheduleMaintenance: async (maintenanceData) => {
    try {
      const response = await api.post('/maintenance', maintenanceData);
      return response.data;
    } catch (error) {
      console.error('Error scheduling maintenance:', error);
      throw error;
    }
  },

  // Generate invoice
  generateInvoice: async (invoiceData) => {
    try {
      const response = await api.post('/invoices', invoiceData);
      return response.data;
    } catch (error) {
      console.error('Error generating invoice:', error);
      throw error;
    }
  },

  // Upload document
  uploadDocument: async (documentData) => {
    try {
      const response = await api.post('/documents', documentData);
      return response.data;
    } catch (error) {
      console.error('Error uploading document:', error);
      throw error;
    }
  }
};

export default dashboardService;